var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditorBold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.798 11.701c.646-.83.998-1.85 1.002-2.901C17.8 6.154 15.646 4 13 4H5v16h8.533c2.647 0 4.8-2.154 4.8-4.8a4.778 4.778 0 0 0-1.535-3.499ZM13 7.2c.882 0 1.6.718 1.6 1.6 0 .882-.718 1.6-1.6 1.6H8.2V7.2H13Zm.533 9.6H8.2v-3.2h5.333c.883 0 1.6.718 1.6 1.6 0 .882-.717 1.6-1.6 1.6Z",
    fill: "#374151"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditorBold);
export default __webpack_public_path__ + "static/media/editor-bold.404aa39e676b4fbbd10d75849489d316.svg";
export { ForwardRef as ReactComponent };